import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

// Two shapes: a compact icon-only circle on small screens, and a labeled pill on wider ones.
export const WARMUP_FAB_COMPACT_SIZE = 60;
export const WARMUP_FAB_WIDTH = 132;
export const WARMUP_FAB_HEIGHT = 56;

export const warmupFabStyles = StyleSheet.create({
  // Shared visual; dimensions/shape come from `circle` or `pill`. Position is applied via
  // the Animated transform.
  fabBase: {
    position: 'absolute',
    top: 0,
    left: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: WARMUP_COLORS.purple,
    borderWidth: 2,
    borderColor: WARMUP_COLORS.text,
    // Lift it off the feed.
    shadowColor: WARMUP_COLORS.purpleDeep,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.6,
    shadowRadius: 14,
    elevation: 10,
    zIndex: 50,
  },
  circle: {
    width: WARMUP_FAB_COMPACT_SIZE,
    height: WARMUP_FAB_COMPACT_SIZE,
    borderRadius: WARMUP_FAB_COMPACT_SIZE / 2,
  },
  pill: {
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: 16,
    width: WARMUP_FAB_WIDTH,
    height: WARMUP_FAB_HEIGHT,
    borderRadius: WARMUP_FAB_HEIGHT / 2,
  },
  label: {
    color: WARMUP_COLORS.textOnBright,
    fontSize: 16,
    fontWeight: '800',
    letterSpacing: 0.2,
  },
  // Soft halo ring drawn behind the button: a gentle ripple, not a solid pump.
  pulseRingCircle: {
    position: 'absolute',
    width: WARMUP_FAB_COMPACT_SIZE,
    height: WARMUP_FAB_COMPACT_SIZE,
    borderRadius: WARMUP_FAB_COMPACT_SIZE / 2,
    borderWidth: 2,
    borderColor: WARMUP_COLORS.purple,
  },
  pulseRingPill: {
    position: 'absolute',
    width: WARMUP_FAB_WIDTH,
    height: WARMUP_FAB_HEIGHT,
    borderRadius: WARMUP_FAB_HEIGHT / 2,
    borderWidth: 2,
    borderColor: WARMUP_COLORS.purple,
  },
  // Small flame badge in the corner → signals "daily streak game".
  badge: {
    position: 'absolute',
    top: -6,
    right: -6,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: WARMUP_COLORS.amber,
    borderWidth: 2,
    borderColor: WARMUP_COLORS.bg,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeEmoji: {
    fontSize: 12,
  },
});
